module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_skin.3db8f9c2.png";